import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgEdit = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M19 13.476a1 1 0 1 1 2 0v4.746A2.778 2.778 0 0 1 18.222 21H5.778A2.778 2.778 0 0 1 3 18.222V5.778A2.778 2.778 0 0 1 5.778 3h4.746a1 1 0 1 1 0 2H5.778A.778.778 0 0 0 5 5.778v12.444c0 .43.348.778.778.778h12.444c.43 0 .778-.348.778-.778v-4.746zm2.707-7.183a1 1 0 0 1 0 1.414l-9 9A1 1 0 0 1 12 17H8a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l9-9a1 1 0 0 1 1.414 0l4 4zM17 4.414l-8 8V15h2.586l8-8L17 4.414z" }));
};
export default factorySvgIcon(SvgEdit);
//# sourceMappingURL=SvgEdit.js.map